import {
  Box,
  Checkbox,
  Drawer,
  FormControlLabel,
  FormGroup,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import XIcon from "../assets/svg/xIcon.svg";
import ArrUp from "../assets/svg/ArrUp.svg";
import axios from "axios";
import { GetAllRoles } from "../URLs/Apis";
import { useSelector } from "react-redux";

function FillterBy({
  selectedJobTitles,
  setSelectedJobTitles,
  handleJobTitleChange,
  open,
  toggleDrawer,
  filteredStaff,
  joinDate,
  setjoinDate,
}) {
  const { user } = useSelector((state) => state.auth);

  const [openFilterjob, setOpenFilterjob] = useState(true);
  const [openFilterdate, setOpenFilterdate] = useState(true);
  const [theCommponent, setTheCommponent] = useState("");

  const [thedatefilter, setThedatefilter] = useState("");
  useEffect(() => {
    getRolesData();
    setTheCommponent(
      (prev) => (prev = window.location.pathname.split("/").filter(Boolean)[0])
    );
  }, [joinDate]);
  const [rolesData, setRolesData] = useState([]);
  const getRolesData = () => {
    if (theCommponent === "clients") return;
    const headers = {
      Authorization: "Bearer " + user?.token,
    }; // auth header with bearer token
    console.log(headers);

    axios
      .get(GetAllRoles, { headers })
      .then((response) => {
        console.log(response);
        setRolesData(response.data.data.categories);
      })
      .catch((error) => {
        console.log(error.data);
      });
  };

  const resetAllFun = () => {
    setjoinDate("");
    handleJobTitleChange("");
    setSelectedJobTitles([]);
  };
  return (
    <Drawer anchor={"right"} open={open} onClose={toggleDrawer(false)}>
      <Box sx={{ width: 350, padding: 3 }} role="presentation">
        <div className="filterBy-title">
          <span className="resetAll" onClick={resetAllFun}>
            Reset all
          </span>
          <span className="filterBy_theTitle">Filter By</span>
          <div className="resetAll" onClick={toggleDrawer(false)}>
            <img className="" src={XIcon} alt="" />
          </div>
        </div>
        <div className="filterBygroping">
          <div className="filterBySection">
            <div
              className="front"
              onClick={() => setOpenFilterjob(!openFilterjob)}
            >
              {theCommponent === "operation" ? (
                <span>Role Name</span>
              ) : theCommponent === "staff" ? (
                <span>Job Title</span>
              ) : (
                <span>Clients Class</span>
              )}
              <img
                src={ArrUp}
                className={`${openFilterjob ? null : "rotat180"}`}
                alt=""
              />
            </div>
            <div className={`back ${openFilterjob ? null : "d-none"}`}>
              {theCommponent === "operation" ? (
                <FormGroup>
                  {rolesData?.map((role) => {
                    return (
                      <FormControlLabel
                        control={
                          <Checkbox
                            inputProps={{ "aria-label": "controlled" }}
                            checked={selectedJobTitles?.includes(role)}
                            onChange={() => handleJobTitleChange(role)}
                          />
                        }
                        label={role}
                      />
                    );
                  })}
                </FormGroup>
              ) : theCommponent === "staff" ? (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        inputProps={{ "aria-label": "controlled" }}
                        checked={selectedJobTitles?.includes("engineer")}
                        onChange={() => handleJobTitleChange("engineer")}
                      />
                    }
                    label="Engineers"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        inputProps={{ "aria-label": "controlled" }}
                        checked={selectedJobTitles?.includes("driver")}
                        onChange={() => handleJobTitleChange("driver")}
                      />
                    }
                    label="Drivers"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        inputProps={{ "aria-label": "controlled" }}
                        checked={selectedJobTitles?.includes("technician")}
                        onChange={() => handleJobTitleChange("technician")}
                      />
                    }
                    label="Technicians"
                  />
                </FormGroup>
              ) : (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        inputProps={{ "aria-label": "controlled" }}
                        checked={selectedJobTitles?.includes("gold")}
                        onChange={() => handleJobTitleChange("gold")}
                      />
                    }
                    label="Gold"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        inputProps={{ "aria-label": "controlled" }}
                        checked={selectedJobTitles?.includes("silver")}
                        onChange={() => handleJobTitleChange("silver")}
                      />
                    }
                    label="Silver"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        inputProps={{ "aria-label": "controlled" }}
                        checked={selectedJobTitles?.includes("bronze")}
                        onChange={() => handleJobTitleChange("bronze")}
                      />
                    }
                    label="Bronze"
                  />
                </FormGroup>
              )}
            </div>
            {theCommponent !== "clients" ? (
              <>
                <div
                  className="front"
                  onClick={() => setOpenFilterdate(!openFilterdate)}
                >
                  <span>Joined date</span>
                  <img
                    src={ArrUp}
                    className={`${openFilterdate ? null : "rotat180"}`}
                    alt=""
                  />
                </div>
                <div className={`back ${openFilterdate ? null : "d-none"}`}>
                  <TextField
                    className="w-100"
                    label="Joined at"
                    type="date"
                    placeholder="DD/MM/YYYY"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    value={joinDate}
                    onChange={(e) => setThedatefilter(e.target.value)}
                  />
                </div>
              </>
            ) : null}
          </div>

          <button
            onClick={() => {
              setjoinDate(thedatefilter);
              toggleDrawer(false);
            }}
            className="filterBy-Sub"
          >
            Show {filteredStaff} results
          </button>
        </div>
      </Box>
    </Drawer>
  );
}

export default FillterBy;
